import { Card, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { withRouter } from 'react-router-dom';
import ChartHeader from './ChartHeader';
import { useBoundStore } from '../../../store/useBoundStore';

const BarChart = ({ response, history, userType }) => {
    const [chartData, setChartData] = useState(null);
    const { resetRSFSFilters, setRSFSFilters, RSFSCardFilters } = useBoundStore();

    useEffect(() => {
        const fetchData = () => {
            const labels = (response && response.chartData && response.chartData.labels) ? response.chartData.labels : [];
            const rawData = (response && response.chartData && response.chartData.data) ? response.chartData.data : [];
            // Hide bars for zero values by converting 0 to null (Chart.js skips nulls)
            const processedData = Array.isArray(rawData) ? rawData.map(v => (v === 0 ? null : v)) : rawData;
            setChartData({
                labels,
                datasets: [
                    {
                        label: (response && response.chartData && response.chartData.name) ? response.chartData.name : "",
                        data: processedData,
                        backgroundColor: (response && response.chartData && response.chartData.backgroundColor) ? response.chartData.backgroundColor : [],
                        minBarLength: 8,
                        barThickness: 13,
                        hoverBackgroundColor: (response && response.chartData && response.chartData.backgroundColor) ?
                            response.chartData.backgroundColor.map(color => `${color}CC`) : [],
                        buckets: (response && response.chartData && response.chartData.buckets) ? response.chartData.buckets : []
                    },
                ],
            });
        };

        fetchData();
    }, [response]);


    if (!chartData) {
        return <div>Loading...</div>;
    }


    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            xAxes: [
                {
                    ticks: {
                        display: true,
                        // minRotation: 0,
                        // maxRotation: 0,
                        // callback: function (value) {
                        //     return value;
                        // },
                    },
                    gridLines: {
                        display: false,
                    },
                    scaleLabel: {
                        display: true,
                        //labelString: 'X Axis',
                    },
                },
            ],
            yAxes: [
                {
                    ticks: {
                        display: true, // Hide y-axis labels
                        beginAtZero: true,
                        callback: function (value) {
                            if (Number.isInteger(value)) {
                                return value;
                            }
                            return '';
                        }
                    },
                    gridLines: {
                        display: true, // Hide y-axis grid lines,
                    },
                    // Keep axis lines visible
                    scaleLabel: {
                        display: true,
                        // labelString: 'Y Axis',
                    },
                },
            ],
        },
        legend: {
            display: false, // Hide legend
        },
        tooltips: {
            enabled: true,
        },
        onClick: (event, chartElement) => {
            if (chartElement.length > 0) {
                let rsFSCardFilters = RSFSCardFilters.datemodified;
                // resetRSFSFilters();
                setRSFSFilters({
                    datemodified: {
                        start_date: rsFSCardFilters.start_date,
                        end_date: rsFSCardFilters.end_date
                    },
                    selectedButton: 'AllBFiles',
                });

                const index = chartElement[0]._index;
                const card = JSON.parse(localStorage.getItem('card'));
                const label = chartData.labels[index];
                const value = chartData.datasets[0].data[index];
                const bucket = chartData.datasets[0].buckets[index];
                if (card && card.user_id) {
                    bucket.userName = card.userName;
                    bucket.user_id = card.user_id;
                    bucket.showName = true;
                }
                localStorage.setItem('card', JSON.stringify(bucket));
                history.push({
                    pathname: "/dashboard/rsfs-grid",
                    search: `?title=${encodeURIComponent(label)}`,
                    state: { card: bucket }
                });

                // Optional: use history.push or navigate
                // history.push('/details', { label, value, bucket });
            }
        },
        onHover: (event, chartElement) => {
            // Chart.js v3+ uses event.native, v2 uses event.nativeEvent, fallback to event
            const target = (event && (event.native ? event.native.target : event.nativeEvent ? event.nativeEvent.target : event.target));
            if (target) {
                if (chartElement && chartElement.length) {
                    target.style.cursor = 'pointer';
                } else {
                    target.style.cursor = 'default';
                }
            }
        }

    };

    return (
        <div>
            <ChartHeader
                headerName={response && response.chartData && response.chartData.name ? response.chartData.name : ""}
                callCount={response && response.chartData && response.chartData.callCount ? response.chartData.callCount : 0}
                date={response && response.chartData && response.chartData.date ? response.chartData.date : ""}
                dateTo={response && response.chartData && response.chartData.dateTo ? response.chartData.dateTo : ""}
                userType={userType}
            />

            <div className='pt-40 mt-40'>
                <Bar data={chartData} options={options}
                    height={350}
                />
            </div>
        </div>
    )
}

export default withRouter(BarChart);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/shared-charts/BarChart.js